import React, { FC, memo } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import { TEXTS } from '../../texts';
import ReportSelectionHeader from '../../ReportSelectionHeader';
import type { AddressSelectionActionsProps } from './types';

import styles from '../index.module.scss';

const AddressSelectionActions: FC<AddressSelectionActionsProps> = ({
  hasSelectedAddresses,
  hasUnselectedAddresses,
  selectedCount,
  onReset,
  onSelectAll,
}) => (
  <ReportSelectionHeader
    actionsTestId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_ACTIONS}
    className={styles.selectionHeader}
    isMobileStacked
    resetAction={
      hasSelectedAddresses
        ? {
            testId: DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_RESET_BUTTON,
            text: TEXTS.AUDIO_REPORT_ADDRESSES_RESET,
            onClick: onReset,
          }
        : undefined
    }
    selectAllAction={
      hasUnselectedAddresses
        ? {
            testId: DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_SELECT_ALL_BUTTON,
            text: TEXTS.AUDIO_REPORT_ADDRESSES_SELECT_ALL,
            onClick: onSelectAll,
          }
        : undefined
    }
    selectedCount={TEXTS.AUDIO_REPORT_ADDRESSES_SELECTED_COUNT(selectedCount)}
    selectedCountTestId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_SELECTED_COUNT}
    testId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESSES_HEADER}
  />
);

export default memo(AddressSelectionActions);
